export const audienceKeys = {
  all: ['audience'] as const,
  segments: () => [...audienceKeys.all, 'segments'] as const,
  segment: (id: string) => [...audienceKeys.all, 'segment', id] as const,
};
